/* @flow */
import React from 'react';
import './tile.css';
import './tile/up.png';
import './tile/down.png';

function Tile(props) {
  const pctClassName = 'percentage-change ' + (props.percentageChange >= 0 ? 'incr' : 'decr');
  let figure = props.figure;
  if (props.formatter) {
    figure = props.formatter(figure);
  }
  const percentageChange = (props.percentageChange >= 0.0 ? props.percentageChange : props.percentageChange * -1);
  return (
    <div className="Tile">
      <p className="figure">{figure}</p>
      <p className={pctClassName}>{percentageChange}%</p>
      <h3>{props.title}</h3>
      {props.footElement}
    </div>
  );
};

export default Tile;



// WEBPACK FOOTER //
// ./src/app/stats/container/shop/tile.js